import produce from 'immer';
import { SingleLineOptions } from 'components/widgets/Trends/components/TrendsGraph/TrendsGraph';
import { Dataset } from 'components/widgets/Trends/Trends';

export const getDataSetBySelectedItem = (selectedOption, groupedData, singleLine: SingleLineOptions) => {
    const datasetTemp: Dataset[] = [];
    if (singleLine === 'Single Parameter (Actual value)') {
        const item = groupedData[selectedOption.value];
        if (item) {
            for (let i = 0; i < item.length; i++) {
                datasetTemp.push(groupedData[selectedOption.value][i]);
            }
        }
    } else {
        selectedOption.forEach((item) => {
            if (groupedData[item.value]?.length) {
                for (let i = 0; i < groupedData[item.value]?.length; i++) {
                    datasetTemp.push(groupedData[item.value][i]);
                }
            }
        });
    }
    return datasetTemp;
};

export const getPreDefinedListObj = (selectedOption, preDefinedList) => {
    const preDefinedObj = preDefinedList.find((item) => item.id === selectedOption.value);
    return preDefinedObj.options.map((item, index) => ({
        id: index,
        label: item,
        value: item,
    }));
};

export const getPreDefinedCrossVersionsData = (data, preDefinedList) => {
    const defaultPreDefinedItem = preDefinedList.find((item) => item.selected === true);
    if (data) {
        return produce(data, (draft) => {
            for (const value of Object.values(draft)) {
                const typedValue = value as any;
                const isInOptions = defaultPreDefinedItem?.options.find((item) => item === typedValue.title);
                typedValue.selectedByDefault = !!isInOptions;
            }
        });
    }

    return data;
};

export const preDefinedList = [
    {
        id: 'Progress vs Criticality ratio',
        label: 'Progress vs Criticality ratio',
        selected: false,
        options: [
            'Progress : Activities Completed %(Actual/Planned Tasks)',
            'Progress: Milestones Completed %(Actual/Planned)',
            'Progress : Criticality Completed %(Sum Criticality (Actual/Planned))',
        ],
        note: 'Look for: If there is a growing gap between total Activities Completed vs Criticality Completed ratio (Activities ratio increase but Criticality ratio is not increasing) then focus is misguided.',
    },
    {
        id: 'Schedule Consistency',
        label: 'Schedule Consistency',
        selected: false,
        options: [
            'Consistency: Date Changes Start (Planned/Actual)',
            'Consistency: Date Changes Finish (Planned/Actual)',
            'Relationships: Count Changes Per Relationship Type',
            'Task dependent: Total Count',
        ],
        note: 'Look for: Significant changes in the other parameters while Activities count is relatively stable mean the schedule is not stable.',
    },
    {
        id: 'Relationship Consistency',
        label: 'Relationship Consistency',
        selected: true,
        options: ['Relationships: Count Changes Per Relationship Type', 'Task dependent: Total Count'],
        note: 'Look for: FS decreasing and SS or SF increasing (while total activities count is stable) means activities are converted from sequential to parallel.',
    },
    {
        id: 'Anomaly in Burn Rate pace',
        label: 'Anomaly in Burn Rate pace',
        selected: false,
        options: [
            'Progress : Activities Completed %(Actual/Planned Tasks)',
            'Progress: Milestones Completed %(Actual/Planned)',
            'Progress: Start Progress Index (Start Actual/Start Planned)',
        ],
        note: 'Look for: If there is a growing gap between total Activities Completed vs Start Progress Index then the contractor is marking activities as completed but not starting new ones.',
    },
    {
        id: 'Program time extension vs level of details',
        label: 'Program time extension vs level of details',
        selected: false,
        options: [
            'Duration: WBS Duration (Total Sum in Months)',
            'Duration: Tasks Duration (Total Sum in Months)',
            'Task dependent: Total Count',
            'Milestones: Total Count',
        ],
        note: 'Look for: If Activities count is increasing and Duration is not increasing then program details are added (OK). If Activities count is increasing and Duration is increasing then program schedule overrun is increasing. If Duration is increasing and Activities count is not increasing then Activities duration is being extended.',
    },
    {
        id: 'Critical Path Congestion over time',
        label: 'Critical Path Congestion over time',
        selected: false,
        options: [
            'Duration: Tasks Duration (Total Sum in Months)',
            'Duration: Float (Total Sum in Months)',
            'Duration: Lag (Total Sum in Months)',
        ],
        note: 'Look for: If Float is decreasing and Duration is not decreasing then Critical Path Congestion is increasing.',
    },
    {
        id: 'Total Activities Consistency',
        label: 'Total Activities Consistency',
        selected: false,
        options: ['Task dependent: Total Count', 'Task dependent: Added', 'Task dependent: Deleted'],
        note: 'Look for: Find anomaly in the proportion of add/deleted compared to total number.',
    },
    {
        id: 'Total Milestones Consistency',
        label: 'Total Milestones Consistency',
        selected: false,
        options: ['Milestones: Added', 'Milestones: Deleted ', 'Milestones: Total Count'],
        note: 'Look for: Find anomaly in the proportion of add/deleted compared to total number.',
    },
];

export const mapOptions = (item, index) => ({ id: index, value: item.label, label: item.label, note: item.note });

export const mapEntries = (item: [string, any], index) => ({
    id: index,
    value: item[1][0].title,
    label: item[1][0].title,
});
